module.exports = __webpack_public_path__ + "static/media/Cross-Right.60e5e3c8.png";